import { render, staticRenderFns } from "./ShowExpense.vue?vue&type=template&id=391e4a36&"
import script from "./ShowExpense.vue?vue&type=script&lang=js&"
export * from "./ShowExpense.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports